import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import { toast } from "react-toastify";
import MDNumberFormatInput from "components/MDNumberFormatInput";

const NewSubscriptionPlan = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        plan_name: "",
        billing_cycle: null,
        description: "",
        price_per_device: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        const templates = {
            ...formData,
        }

        try {
            await CrudService.createSubscriptionPlan(templates);
            navigate("/subscription-plan", {
                state: { value: true, text: "The subscription plan was successfully created" },
            });
            toast.success("The subscription plan was successfully created")
        } catch (err) {
            console.error(err);
            toast.error(err.error)
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={5} mb={9}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={6} mb={8} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    Add New Subscription Plan
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox component="form" onSubmit={submitHandler} >
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>

                                    <TextField fullWidth label="Plan Name" name="plan_name" value={formData.plan_name} onChange={handleChange} margin="normal" required />
                                    <TextField fullWidth label="Description" name="description" value={formData.description} onChange={handleChange} margin="normal" />
                                    <FormControl sx={{ mt: 1 }} required>
                                        <InputLabel id="billing_cycle">Billing Cycle</InputLabel>
                                        <Select
                                            labelId="billing_cycle"
                                            id="billing_cycle"
                                            name="billing_cycle"
                                            value={formData.billing_cycle}
                                            label="Billing Cycle"
                                            onChange={handleChange}
                                            sx={{
                                                '& .MuiSelect-select': {
                                                    minHeight: '3em !important'
                                                }
                                            }}
                                            required
                                        >
                                            <MenuItem value="">Select an option</MenuItem>
                                            <MenuItem value="monthly">Monthly</MenuItem>
                                            <MenuItem value="yearly">Yearly</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <MDNumberFormatInput fullWidth label="Price Per Device" name="price_per_device" value={formData.price_per_device} onChange={handleChange} margin="normal" required />
                                    <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/subscription-plan", {
                                                        state: { value: false, text: "" },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                        <MDButton variant="gradient" color="dark" size="small" type="submit" >
                                            Save
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default NewSubscriptionPlan;
